import { Atom, atom } from 'jotai';
import { Product } from '../Models/Product';
import apiClient, {
    GeoRestrictionStatus,
    InkyApiError,
    InkyApiGeoRestrictedError,
    InkyApiStatus,
} from '../API/InkyAPI';
import { atomFamily } from 'jotai/utils';
import fakeJson from '../test/FakeJson';
import { CurrentPage } from './ReaderStore';
import { AccountInfoAtom } from './AccountStore';
import { DebugModeEnabledAtom } from './DebugStore';


export const ProductErrorAtom = atom<string | false>(false);


export const ProductsAtomFamily = atomFamily(() => atom<Product | false>(false));
export const FetchProductAtomV2 = atomFamily((id: number) =>
atom(
    (get): Product | false => {
        return get(ProductsAtomFamily(id));
    },
async (get, set, update: any ): Promise<Product | false> => {
    const product = get(ProductsAtomFamily(id));

    if(product){
        return product;
    }

    try {

        const accountInfo = get(AccountInfoAtom);
        const debugMode = get(DebugModeEnabledAtom);
        const isAdmin = accountInfo.roles?.some(x => x.toLowerCase() == 'admin');



        const newproduct = await apiClient.getProductById(id.toString(), null, 600);
        if(newproduct){
            console.log("Product fetced", newproduct);
            set(ProductsAtomFamily(id), newproduct);
            set(ProductErrorAtom, false);

            if(newproduct.readable.readingProgress != null){
                set(CurrentPage, newproduct.readable.readingProgress)
            }

        }
    } catch (e) {

        if(e instanceof InkyApiError){
            console.warn("InkyAPi Error", e.status)

            if( e instanceof  InkyApiGeoRestrictedError){
                switch (e.geoRestrictionStatus){
                    case "NotRestricted":
                        set(ProductsAtomFamily(id), e.payload);
                        break;
                    case "RestrictedButOwned":
                        console.warn("Product is restricted but user owns it");
                        set(ProductsAtomFamily(id), e.payload);
                        break;
                    case "RestrictedWithData":
                        console.warn("Product is restricted but data not sensitive");
                        set(ProductErrorAtom, "Product not available in your region");
                        set(ProductsAtomFamily(id), e.payload);
                        break;
                    case "RestrictedButAdmin":
                        console.warn("Product is restricted but user is admin");
                        set(ProductsAtomFamily(id), e.payload);
                        break;
                    case "Restricted":
                        console.warn("Product not available in your region");
                        set(ProductErrorAtom, "Product not available in your region");
                }

            }

            switch (e.status) {
                case InkyApiStatus.NotFound:
                    console.warn("Product not found");
                    set(ProductErrorAtom, "Product was not found");
                    break;
                default:
                    console.error("[ProductStore] Could not fetch Product-data: " + e.message, e);
                    set(ProductErrorAtom, "Product was not found (Uknown error?)");
                    throw e;
            }
        } else {
            console.error("[ProductStore] Could not fetch Product-data: " + e.message, e);
            set(ProductErrorAtom, "Product was not found (Uknown error?)");
            throw e;
        }
    }



    return get(ProductsAtomFamily(id));

}
));
